import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import PageTemplate from '../../components/Common/PageTemplate';

const BatiAsyaTatlisulariKapsamliKitap = () => {
  return (
    <PageTemplate
      title="Batı Asya Tatlısu Balıkları İçin Kapsamlı Başvuru Kitabı Yayımlandı"
      subtitle="Doç. Dr. Baran Yoğurtçuoğlu'nun yazarları arasında bulunduğu 'Handbook of Freshwater Fishes of West Asia', De Gruyter tarafından yayımlandı."
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl -mt-16 relative z-10 mb-16">

          <div className="flex flex-col lg:flex-row gap-10 items-start">
            <div className="lg:w-1/3 flex-shrink-0">
              <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-100">
                <img
                  src="https://fs.hacettepe.edu.tr/fenyeni/resimler/_/_2/b2.jfif"
                  alt="Handbook of Freshwater Fishes of West Asia kitap kapağı"
                  className="w-full h-auto object-cover"
                  loading="eager"
                />
              </div>
            </div>

            <div className="lg:w-2/3 space-y-5">
              {/* Kitap Adı */}
              <div>
                <p className="text-2xl font-bold text-hacettepe-blue italic">Handbook of Freshwater Fishes of West Asia</p>
                <p className="text-base text-gray-500 mt-1">Batı Asya Tatlısu Balıkları El Kitabı</p>
              </div>

              {/* Yazarlar */}
              <div className="flex flex-wrap gap-2">
                {[
                  { name: 'Doç. Dr. Baran Yoğurtçuoğlu', color: 'bg-hacettepe-red text-white' },
                  { name: 'Jörg Freyhof', color: 'bg-blue-600 text-white' },
                  { name: 'Arash Jouladeh-Roudbar', color: 'bg-emerald-600 text-white' },
                  { name: 'Cüneyt Kaya', color: 'bg-purple-600 text-white' },
                ].map((author, i) => (
                  <span key={i} className={`px-4 py-1.5 rounded-full text-sm font-semibold ${author.color}`}>
                    {author.name}
                  </span>
                ))}
              </div>

              {/* Metin */}
              <p className="text-lg leading-relaxed text-gray-700">
                Fakültemiz Biyoloji Bölümü Öğretim Üyesi Doç. Dr. Baran Yoğurtçuoğlu'nun yazarları arasında bulunduğu "Handbook of Freshwater Fishes of West Asia" (Batı Asya Tatlısu Balıkları El Kitabı) başlıklı kapsamlı çalışma yayımlandı. De Gruyter yayınevi tarafından 2025 yılı Aralık ayında yayımlanan ve yaklaşık 20 yıllık bir saha araştırmasının ürünü olan bu eser, Doç. Dr. Baran Yoğurtçuoğlu ile birlikte Jörg Freyhof, Arash Jouladeh-Roudbar ve Cüneyt Kaya tarafından kaleme alınmıştır. Açık erişim olarak bilim dünyasına sunulan kitap, Türkiye'nin Anadolu kısmından Kafkasya'ya, İran'dan Arap Yarımadası'na kadar uzanan geniş bir coğrafyadaki tatlı su balık çeşitliliğini kapsamlı bir şekilde ele almaktadır. Eser, türlerin tanımlayıcı özelliklerinin yanı sıra güncel IUCN Kırmızı Liste koruma statülerini, detaylı dağılım haritalarını ve ekolojik tehditleri de içermektedir. Bu rehberin, bölgedeki su ekosistemlerinin korunmasına yönelik stratejilerin belirlenmesinde temel bir kaynak teşkil etmesi beklenmektedir.
              </p>
            </div>
          </div>

        </div>

        <div className="text-center mb-16">
          <Link
            to="/haberler"
            className="group inline-flex items-center px-8 py-4 bg-gradient-to-r from-gray-800 to-gray-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-gray-300"
          >
            <FaArrowLeft className="mr-3 -ml-1 h-5 w-5 group-hover:-translate-x-1 transition-transform duration-300" />
            Tüm Haberlere Geri Dön
          </Link>
        </div>
      </div>
    </PageTemplate>
  );
};

export default BatiAsyaTatlisulariKapsamliKitap;
